import { Box, Collapse, IconButton, Table, TableCell, TableRow, TableHead, TableBody } from "@material-ui/core";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { FcTimeline } from 'react-icons/fc';
import React, { useEffect } from "react";
import { useState } from "react";
import { BsFileText } from "react-icons/bs";
import { usePedidos } from "../../../../contexts/Pedidos";
import ReactLoading from 'react-loading';
import { TimelineConsultaPedidos } from "../TimelineConsultaPedido";
import { TextOnlyTooltip } from "../../../../themes/components/TextOnlyTooltip";

interface HistPedido {
    evento: [
        {
            dateve: string,
            deseve: string,
            esteve: string,
            horeve: string
        }]
}

interface arrayHistPedidos {
    length: number;
    [index: number]: HistPedido
}

export function RowListaPedidos(props: {
    row: ReturnType<any>,
    handleModal: (numped: number, codemp: string) => void,
    history: ReturnType<any>,
    index: number,
    estoque: any
}) {
    const { row, handleModal, history } = props;
    const { buscarHistoricoPed } = usePedidos();
    const [open, setOpen] = useState(false);
    const [localHistorico, setLocalHistorico] = useState<arrayHistPedidos>([]);
    const [localLoading, setLocalLoading] = useState(true);
    const [estoque, setEstoque] = useState("0");
    

    useEffect(() => {
        async function teste() {
            let hist = await buscarHistoricoPed(row.numPed, row.codEmp, history)
            setLocalHistorico(hist);
            setLocalLoading(false);
        }
        if (open === true) {
            setLocalLoading(true);
            teste();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    useEffect(() =>{
        setEstoque(props.estoque);
    }, [props.estoque]);

    function sitPedidos(codSit:String){
        switch(codSit){
            case "1":{
                return "Aberto Total";
            }
            case "2":{
                return "Aberto Parcial";
            }
            case "3":{
                return "";
            }
            case "4":{
                return "Liquidado";
            }
            case "5":{
                return "Cancelado";
            }
        }
        
    }

    let pedidos = (
        <React.Fragment>
            <TableRow className={`linha_${props.index % 2 === 0 ? "par" : "impar"}`}>
                <TableCell scope="row" style={{ border: 'none', display: "flex", justifyContent: "row", padding: "0px" }} ><div style={{ backgroundColor: row.codEmp == 2 ? "#0252a8" : row.codEmp == 4 ? "#FF4800" : row.codEmp, width: "5px", height: "85px", margin: "0px 10px 0px 0px" }}></div><div style={{ margin: "33px 0px 0px 0px" }}>{row.numPed}</div></TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.nomCli}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.codEmp == 2 ? "GA" : row.codEmp == 4 ? "AB" : row.codEmp}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{row.datEmi}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{row.datPrv}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{sitPedidos(row.sitPed)}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.qtdOri).toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.vlrOri).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <TextOnlyTooltip title="Detalhes" placement="top">
                        <button style={{ backgroundColor: 'transparent', border: '0px' }} onClick={() => handleModal(row.numPed, row.codEmp)} >
                            <BsFileText size="22" color={"#003388"} />
                        </button>
                    </TextOnlyTooltip>
                </TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ?
                            <KeyboardArrowUpIcon />
                            :
                            <TextOnlyTooltip title="Linha do Tempo" placement="top">
                                <button type="button" style={{ border: 'none', backgroundColor: 'transparent' }}><FcTimeline /></button>
                            </TextOnlyTooltip>
                        }
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: '1px solid #ccc' }} colSpan={9}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {localLoading ?
                            <div style={{ display: 'flex', marginBottom: "2em", alignItems: 'center', justifyContent: 'center' }}>
                                <ReactLoading type={"bars"} color={"#0252a8"} height={25} width={50} />
                            </div>
                            :
                            <Box margin={1}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Andamento do Pedido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {localHistorico instanceof Array && localHistorico.length > 0 ?
                                            <TimelineConsultaPedidos historico={localHistorico}/>
                                            :
                                            <TableRow>
                                                <TableCell>Nenhuma informação encontrada.</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </Box>
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )

    return (

    estoque == "0" ? pedidos : row.codEmp == estoque  ? pedidos : null
      
        
    );
}

